/* Shared country-code dial with flags (account + Notify me). */
(function (root) {
  'use strict';

  var DIALS = [
    { v: '966', iso: 'sa', t: 'SA +966' },
    { v: '971', iso: 'ae', t: 'AE +971' },
    { v: '973', iso: 'bh', t: 'BH +973' },
    { v: '974', iso: 'qa', t: 'QA +974' },
    { v: '968', iso: 'om', t: 'OM +968' },
    { v: '965', iso: 'kw', t: 'KW +965' },
    { v: '962', iso: 'jo', t: 'JO +962' },
    { v: '961', iso: 'lb', t: 'LB +961' },
    { v: '964', iso: 'iq', t: 'IQ +964' },
    { v: '967', iso: 'ye', t: 'YE +967' },
    { v: '20', iso: 'eg', t: 'EG +20' },
    { v: '212', iso: 'ma', t: 'MA +212' },
    { v: '213', iso: 'dz', t: 'DZ +213' },
    { v: '216', iso: 'tn', t: 'TN +216' },
    { v: '90', iso: 'tr', t: 'TR +90' },
    { v: '44', iso: 'gb', t: 'UK +44' },
    { v: '353', iso: 'ie', t: 'IE +353' },
    { v: '33', iso: 'fr', t: 'FR +33' },
    { v: '49', iso: 'de', t: 'DE +49' },
    { v: '39', iso: 'it', t: 'IT +39' },
    { v: '34', iso: 'es', t: 'ES +34' },
    { v: '31', iso: 'nl', t: 'NL +31' },
    { v: '32', iso: 'be', t: 'BE +32' },
    { v: '41', iso: 'ch', t: 'CH +41' },
    { v: '43', iso: 'at', t: 'AT +43' },
    { v: '46', iso: 'se', t: 'SE +46' },
    { v: '47', iso: 'no', t: 'NO +47' },
    { v: '45', iso: 'dk', t: 'DK +45' },
    { v: '358', iso: 'fi', t: 'FI +358' },
    { v: '48', iso: 'pl', t: 'PL +48' },
    { v: '351', iso: 'pt', t: 'PT +351' },
    { v: '30', iso: 'gr', t: 'GR +30' },
    { v: '1', iso: 'us', t: 'US +1' },
    { v: '52', iso: 'mx', t: 'MX +52' },
    { v: '55', iso: 'br', t: 'BR +55' },
    { v: '54', iso: 'ar', t: 'AR +54' },
    { v: '91', iso: 'in', t: 'IN +91' },
    { v: '92', iso: 'pk', t: 'PK +92' },
    { v: '880', iso: 'bd', t: 'BD +880' },
    { v: '62', iso: 'id', t: 'ID +62' },
    { v: '63', iso: 'ph', t: 'PH +63' },
    { v: '60', iso: 'my', t: 'MY +60' },
    { v: '65', iso: 'sg', t: 'SG +65' },
    { v: '66', iso: 'th', t: 'TH +66' },
    { v: '84', iso: 'vn', t: 'VN +84' },
    { v: '86', iso: 'cn', t: 'CN +86' },
    { v: '81', iso: 'jp', t: 'JP +81' },
    { v: '82', iso: 'kr', t: 'KR +82' },
    { v: '852', iso: 'hk', t: 'HK +852' },
    { v: '61', iso: 'au', t: 'AU +61' },
    { v: '64', iso: 'nz', t: 'NZ +64' },
    { v: '27', iso: 'za', t: 'ZA +27' },
    { v: '234', iso: 'ng', t: 'NG +234' },
    { v: '254', iso: 'ke', t: 'KE +254' },
    { v: '7', iso: 'ru', t: 'RU +7' },
    { v: '380', iso: 'ua', t: 'UA +380' }
  ];

  function optionHtml() {
    return DIALS.map(function (d) {
      return '<option value="' + d.v + '" data-iso="' + d.iso + '">' + d.t + '</option>';
    }).join('');
  }

  function digits(raw) {
    return String(raw || '')
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); })
      .replace(/\D/g, '');
  }

  function split(raw) {
    var d = digits(raw);
    if (!d) return { dial: '', local: '' };
    if (d.indexOf('00') === 0) d = d.slice(2);
    var codes = DIALS.map(function (item) { return item.v; })
      .sort(function (a, b) { return b.length - a.length; });
    var i;
    for (i = 0; i < codes.length; i++) {
      if (d.indexOf(codes[i]) === 0 && d.length > codes[i].length) {
        return { dial: codes[i], local: d.slice(codes[i].length) };
      }
    }
    if (d.charAt(0) === '0') d = d.slice(1);
    return { dial: '', local: d };
  }

  function combine(dial, local) {
    var loc = digits(local);
    var code = String(dial || '').replace(/\D/g, '');
    if (!loc) return '';
    if (code && loc.indexOf(code) === 0) return '+' + loc;
    if (loc.charAt(0) === '0') loc = loc.slice(1);
    return code ? '+' + code + loc : '+' + loc;
  }

  function flagUrl(iso) {
    return 'https://flagcdn.com/w40/' + String(iso || '').toLowerCase() + '.png';
  }

  function optionIso(opt) {
    if (!opt) return '';
    var iso = (opt.getAttribute('data-iso') || '').toLowerCase();
    if (iso) return iso;
    var label = String(opt.textContent || '').trim().slice(0, 2).toLowerCase();
    if (label === 'uk') return 'gb';
    return label;
  }

  function flagImg(iso, alt) {
    var img = document.createElement('img');
    img.className = 'addr-flag';
    img.src = flagUrl(iso);
    img.alt = alt || '';
    img.width = 18;
    img.height = 12;
    img.loading = 'lazy';
    img.decoding = 'async';
    return img;
  }

  function closeLists(except) {
    document.querySelectorAll('.addr-dial-list.is-open').forEach(function (list) {
      if (list === except) return;
      list.classList.remove('is-open');
      var wrap = list.closest('.addr-dial-wrap');
      var btn = wrap && wrap.querySelector('.addr-dial-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function fillSelect(select) {
    if (!select || select.options.length) return;
    select.innerHTML = optionHtml();
    if (!select.value) select.value = '966';
  }

  function enhanceSelect(select) {
    if (!select || select.getAttribute('data-dial-enhanced') === '1') return;
    fillSelect(select);
    select.setAttribute('data-dial-enhanced', '1');
    if (!select.classList.contains('addr-dial')) select.classList.add('addr-dial');
    var wrap = document.createElement('div');
    wrap.className = 'addr-dial-wrap';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'addr-dial-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', select.getAttribute('aria-label') || 'Country code');
    wrap.appendChild(btn);

    var list = document.createElement('ul');
    list.className = 'addr-dial-list';
    list.setAttribute('role', 'listbox');
    wrap.appendChild(list);

    Array.prototype.forEach.call(select.options, function (opt) {
      var item = document.createElement('li');
      item.setAttribute('role', 'option');
      item.setAttribute('data-value', opt.value);
      var iso = optionIso(opt);
      if (iso) item.appendChild(flagImg(iso, opt.textContent));
      var label = document.createElement('span');
      label.textContent = String(opt.textContent || '').trim();
      item.appendChild(label);
      item.addEventListener('click', function () {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        closeLists();
      });
      list.appendChild(item);
    });

    function syncButton() {
      var opt = select.selectedOptions && select.selectedOptions[0];
      btn.innerHTML = '';
      var iso = optionIso(opt);
      if (iso) btn.appendChild(flagImg(iso, opt ? opt.textContent : ''));
      var code = document.createElement('span');
      code.className = 'addr-dial-code';
      code.textContent = opt ? '+' + opt.value : '';
      btn.appendChild(code);
      Array.prototype.forEach.call(list.children, function (item) {
        item.setAttribute('aria-selected', item.getAttribute('data-value') === select.value ? 'true' : 'false');
      });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = list.classList.contains('is-open');
      closeLists();
      if (!open) {
        list.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    select.addEventListener('change', syncButton);
    syncButton();
  }

  function enhanceAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('select.addr-dial, [data-addr-dial], [data-profile-dial], [data-l4-notify-dial]').forEach(enhanceSelect);
  }

  function applyToPhoneField(input, raw) {
    if (!input) return;
    var parsed = split(raw);
    var wrap = input.closest('.l4-notify-form__phone-row')
      || input.closest('.addr-phone')
      || input.parentNode;
    var dial = wrap && wrap.querySelector('[data-l4-notify-dial], [data-profile-dial], [data-addr-dial], select.addr-dial');
    if (dial) {
      dial.value = parsed.dial || dial.value || '966';
      dial.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!input.value) input.value = parsed.local || '';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.addr-dial-wrap')) closeLists();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLists();
  });

  function boot() {
    enhanceAll();
    if (document.body && document.body.getAttribute('data-bb-dial-watch') === '1') return;
    if (!document.body) return;
    document.body.setAttribute('data-bb-dial-watch', '1');
    var observer = new MutationObserver(function () { enhanceAll(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  root.BBDial = {
    optionHtml: optionHtml,
    enhanceAll: enhanceAll,
    split: split,
    combine: combine,
    applyToPhoneField: applyToPhoneField
  };
})(window);
